import '@tensorflow/tfjs-backend-webgl';
import { parseGIF, decompressFrames } from 'gifuct-js';
import { HMSVideoPluginType } from '@100mslive/hms-video';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var pkg = /*#__PURE__*/require("../package.json");

var BASE_URL = "https://unpkg.com/" + pkg.name + "/src";
var TAG = 'VBProcessor';
var TFLITE_JS_FILE = 'tflite/tflite.js';
var TFLITE_SIMD_JS_FILE = 'tflite/tflite-simd.js';
var MODEL_FILE_NAME = 'models/selfie_segmentation_landscape.tflite';

var loadScript = function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
};

var loadTFLiteModel = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var tfLite, path;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = BASE_URL + "/" + TFLITE_SIMD_JS_FILE;
            _context.next = 3;
            return loadScript(path);

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return createTFLiteSIMDModule();

          case 6:
            tfLite = _context.sent;
            _context.next = 18;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.warn('SIMD not supported. You may experience poor virtual background effect.');
            path = BASE_URL + "/" + TFLITE_JS_FILE;
            _context.next = 15;
            return loadScript(path);

          case 15:
            _context.next = 17;
            return createTFLiteModule();

          case 17:
            tfLite = _context.sent;

          case 18:
            return _context.abrupt("return", tfLite);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));

  return function loadTFLiteModel() {
    return _ref.apply(this, arguments);
  };
}();

var loadTFLite = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
    var modelPath, _yield$Promise$all, tfLite, modelResponse, model, modelBufferOffset;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            modelPath = BASE_URL + "/" + MODEL_FILE_NAME;
            _context2.next = 3;
            return Promise.all([loadTFLiteModel(), fetch(modelPath)]);

          case 3:
            _yield$Promise$all = _context2.sent;
            tfLite = _yield$Promise$all[0];
            modelResponse = _yield$Promise$all[1];
            _context2.next = 8;
            return modelResponse.arrayBuffer();

          case 8:
            model = _context2.sent;
            modelBufferOffset = tfLite._getModelBufferMemoryOffset();
            tfLite.HEAPU8.set(new Uint8Array(model), modelBufferOffset);

            tfLite._loadModel(model.byteLength);

            console.log(TAG, 'Input memory offset:', tfLite._getInputMemoryOffset());
            console.log(TAG, 'Input height:', tfLite._getInputHeight());
            console.log(TAG, 'Input width:', tfLite._getInputWidth());
            console.log(TAG, 'Input channels:', tfLite._getInputChannelCount());
            return _context2.abrupt("return", tfLite);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loadTFLite() {
    return _ref2.apply(this, arguments);
  };
}();

var TAG$1 = 'VBProcessor';
var DEFAULT_DELAY = 33;

var pkg$1 = /*#__PURE__*/require('../package.json');

var minVideoWidthForSharpening = 214;
var maxVideoWidthForSharpening = 855;
var minVideoHeightForSharpening = 120;
var maxVideoHeightForSharpening = 720;
var HMSVirtualBackgroundPlugin = /*#__PURE__*/function () {
  function HMSVirtualBackgroundPlugin(background, enableSharpening) {
    if (enableSharpening === void 0) {
      enableSharpening = false;
    }

    this.backgroundType = 'none';
    this.background = background;
    this.enableSharpening = enableSharpening;
    this.backgroundImage = null;
    this.backgroundVideo = null;
    this.personMaskWidth = 256;
    this.personMaskHeight = 144;
    this.isVirtualBackground = false;
    this.blurValue = '10px';
    this.loadModelCalled = false;
    this.tfLite = null;
    this.modelName = 'landscape-segmentation';
    this.outputCtx = null;
    this.input = null;
    this.output = null;
    this.timerID = 0;
    this.imageAspectRatio = 1;
    this.personMaskPixelCount = this.personMaskWidth * this.personMaskHeight;
    this.personMask = new ImageData(this.personMaskWidth, this.personMaskHeight);
    this.personMaskCanvas = document.createElement('canvas');
    this.personMaskCanvas.width = this.personMaskWidth;
    this.personMaskCanvas.height = this.personMaskHeight;
    this.personMaskCtx = this.personMaskCanvas.getContext('2d');
    this.filters = {};
    this.gifFrames = null;
    this.gifFramesIndex = 0;
    this.gifFrameImageData = null;
    this.tempGifCanvas = document.createElement('canvas');
    this.tempGifContext = this.tempGifCanvas.getContext('2d');
    this.giflocalCount = 0;
    this.enableSharpening = enableSharpening;
    this.log(TAG$1, 'Virtual Background plugin created');
    this.setBackground(this.background);
  }

  var _proto = HMSVirtualBackgroundPlugin.prototype;

  _proto.init = /*#__PURE__*/function () {
    var _init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.loadModelCalled) {
                _context.next = 9;
                break;
              }

              this.log(TAG$1, 'PREVIOUS LOADED MODEL IS ', this.tfLite);
              this.loadModelCalled = true;
              this.tfLitePromise = loadTFLite();
              _context.next = 6;
              return this.tfLitePromise;

            case 6:
              this.tfLite = _context.sent;
              _context.next = 11;
              break;

            case 9:
              _context.next = 11;
              return this.tfLitePromise;

            case 11:
              if (this.enableSharpening) {
                this.initSharpenFilter();
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init() {
      return _init.apply(this, arguments);
    }

    return init;
  }();

  _proto.isSupported = function isSupported() {
    //support chrome, firefox, edge TODO: check this
    return navigator.userAgent.indexOf('Chrome') !== -1 || navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Edg') !== -1;
  };

  _proto.getName = function getName() {
    return pkg$1.name;
  };

  _proto.getPluginType = function getPluginType() {
    return HMSVideoPluginType.TRANSFORM;
  };

  _proto.setBackground = /*#__PURE__*/function () {
    var _setBackground = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(path) {
      var _this = this;

      var img;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(path !== '')) {
                _context3.next = 50;
                break;
              }

              if (!(path === 'none')) {
                _context3.next = 8;
                break;
              }

              this.log(TAG$1, 'setting background to :', path);
              this.background = 'none';
              this.backgroundType = 'none';
              this.isVirtualBackground = false;
              _context3.next = 48;
              break;

            case 8:
              if (!(path === 'blur')) {
                _context3.next = 15;
                break;
              }

              this.log(TAG$1, 'setting background to :', path);
              this.background = 'blur';
              this.backgroundType = 'blur';
              this.isVirtualBackground = false;
              _context3.next = 48;
              break;

            case 15:
              if (!(path instanceof HTMLImageElement)) {
                _context3.next = 29;
                break;
              }

              this.log('setting background to image', path);
              _context3.next = 19;
              return this.setImage(path);

            case 19:
              img = _context3.sent;

              if (!(!img || !img.complete || !img.naturalHeight)) {
                _context3.next = 24;
                break;
              }

              throw new Error('Invalid image. Provide a valid and successfully loaded HTMLImageElement');

            case 24:
              this.isVirtualBackground = true;
              this.backgroundImage = img;
              this.backgroundType = 'image';

            case 27:
              _context3.next = 48;
              break;

            case 29:
              if (!(path instanceof HTMLVideoElement)) {
                _context3.next = 38;
                break;
              }

              this.log('setting background to video', path);
              this.backgroundVideo = path;
              this.backgroundVideo.crossOrigin = 'anonymous';
              this.backgroundVideo.muted = true;
              this.backgroundVideo.loop = true;
              this.backgroundVideo.oncanplaythrough = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
                return runtime_1.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(_this.backgroundVideo != null)) {
                          _context2.next = 5;
                          break;
                        }

                        _context2.next = 3;
                        return _this.backgroundVideo.play();

                      case 3:
                        _this.isVirtualBackground = true;
                        _this.backgroundType = 'video';

                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
              _context3.next = 48;
              break;

            case 38:
              console.log('setting gif to background');
              _context3.next = 41;
              return this.setGiF(path);

            case 41:
              this.gifFrames = _context3.sent;

              if (!(this.gifFrames != null && this.gifFrames.length > 0)) {
                _context3.next = 47;
                break;
              }

              this.backgroundType = 'gif';
              this.isVirtualBackground = true;
              _context3.next = 48;
              break;

            case 47:
              throw new Error('Invalid background supplied, see the docs to check supported background type');

            case 48:
              _context3.next = 51;
              break;

            case 50:
              throw new Error('Invalid background supplied, see the docs to check supported background type');

            case 51:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function setBackground(_x) {
      return _setBackground.apply(this, arguments);
    }

    return setBackground;
  }();

  _proto.stop = function stop() {
    if (this.isVirtualBackground) {
      var _this$backgroundImage, _this$backgroundVideo;

      (_this$backgroundImage = this.backgroundImage) == null ? void 0 : _this$backgroundImage.removeAttribute('src');
      (_this$backgroundVideo = this.backgroundVideo) == null ? void 0 : _this$backgroundVideo.removeAttribute('src');

      if (this.backgroundType === 'video') {
        this.backgroundVideo.loop = false;
        this.backgroundVideo = null;
      }
    }

    if (this.outputCtx) {
      this.outputCtx.fillStyle = "rgb(0, 0, 0)";
      this.outputCtx.fillRect(0, 0, this.output.width, this.output.height);
    } //gif related


    this.gifFrameImageData = null;
    this.gifFrames = null;
    this.giflocalCount = 0;
    this.gifFramesIndex = 0;
  };

  _proto.processVideoFrame = function processVideoFrame(input, output, skipProcessing) {
    var _this2 = this;

    if (!input || !output) {
      throw new Error('Plugin invalid input/output');
    }

    this.input = input;
    this.output = output;
    var ctx = output.getContext('2d');

    if (ctx.canvas.width !== input.width) {
      ctx.canvas.width = input.width;
    }

    if (ctx.canvas.height !== input.height) {
      ctx.canvas.height = input.height;
    }

    if (this.backgroundType === 'video') {
      this.backgroundVideo.width = input.width;
      this.backgroundVideo.height = input.height;
    }

    this.outputCtx = ctx;
    this.imageAspectRatio = input.width / input.height;

    if (this.imageAspectRatio <= 0) {
      throw new Error('Invalid input width/height');
    }

    var process = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4() {
        return runtime_1.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this2.runSegmentation(skipProcessing);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function process() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (this.background === 'none' && !this.isVirtualBackground) {
      this.outputCtx.globalCompositeOperation = 'copy';
      this.outputCtx.filter = 'none';
      this.outputCtx.drawImage(input, 0, 0, input.width, input.height);
    } else {
      process();
    }
  };

  _proto.setImage = /*#__PURE__*/function () {
    var _setImage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(image) {
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              image.crossOrigin = 'anonymous';
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                image.onload = function () {
                  return resolve(image);
                };

                image.onerror = reject;
              }));

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function setImage(_x2) {
      return _setImage.apply(this, arguments);
    }

    return setImage;
  }();

  _proto.setGiF = function setGiF(url) {
    return fetch(url).then(function (resp) {
      return resp.arrayBuffer();
    }).then(function (buff) {
      return parseGIF(buff);
    }).then(function (gif) {
      return decompressFrames(gif, true);
    });
  };

  _proto.log = function log(tag) {
    var _console;

    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    (_console = console).info.apply(_console, [tag].concat(data));
  };

  _proto.resizeInputData = function resizeInputData() {
    this.personMaskCtx.drawImage(this.input, 0, 0, this.input.width, this.input.height, 0, 0, this.personMaskWidth, this.personMaskHeight);
    var imageData = this.personMaskCtx.getImageData(0, 0, this.personMaskWidth, this.personMaskHeight); //

    var inputMemoryOffset = this.tfLite._getInputMemoryOffset() / 4;

    for (var i = 0; i < this.personMaskPixelCount; i++) {
      this.tfLite.HEAPF32[inputMemoryOffset + i * 3] = imageData.data[i * 4] / 255;
      this.tfLite.HEAPF32[inputMemoryOffset + i * 3 + 1] = imageData.data[i * 4 + 1] / 255;
      this.tfLite.HEAPF32[inputMemoryOffset + i * 3 + 2] = imageData.data[i * 4 + 2] / 255;
    }
  };

  _proto.infer = function infer(skipProcessing) {
    if (!skipProcessing) {
      this.tfLite._runInference();
    }

    var outputMemoryOffset = this.tfLite._getOutputMemoryOffset() / 4;

    for (var i = 0; i < this.personMaskPixelCount; i++) {
      if (this.modelName === 'meet') {
        var background = this.tfLite.HEAPF32[outputMemoryOffset + i * 2];
        var person = this.tfLite.HEAPF32[outputMemoryOffset + i * 2 + 1];
        var shift = Math.max(background, person);
        var backgroundExp = Math.exp(background - shift);
        var personExp = Math.exp(person - shift); // Sets only the alpha component of each pixel.

        this.personMask.data[i * 4 + 3] = 255 * personExp / (backgroundExp + personExp);
      } else if (this.modelName === 'landscape-segmentation') {
        var _person = this.tfLite.HEAPF32[outputMemoryOffset + i];
        this.personMask.data[i * 4 + 3] = 255 * _person;
      }
    }

    this.personMaskCtx.putImageData(this.personMask, 0, 0);
  };

  _proto.postProcessing = function postProcessing() {
    this.outputCtx.globalCompositeOperation = 'copy';
    this.outputCtx.filter = 'none';

    if (this.isVirtualBackground) {
      this.outputCtx.filter = 'blur(4px)';
    } else {
      this.outputCtx.filter = 'blur(8px)';
    }

    this.drawPersonMask();
    this.outputCtx.globalCompositeOperation = 'source-in';
    this.outputCtx.filter = 'none'; // //Draw the foreground

    this.outputCtx.drawImage(this.input, 0, 0);

    if (this.enableSharpening && this.output.width > minVideoWidthForSharpening && // minimum and maximum resolution to enable sharpening filter
    this.output.height > minVideoHeightForSharpening && this.output.width < maxVideoWidthForSharpening && this.output.height < maxVideoHeightForSharpening) {
      this.sharpenFilter();
    } // //Draw the background


    this.drawSegmentedBackground();
  };

  _proto.sharpenFilter = function sharpenFilter() {
    // adding sharpening filter to each frame to improve edges and brightness
    // The basic idea is that you take the weighed sum of a rectangle of pixels from the source image and use that as the output value using convolution filter
    // It is applied intermediate output with black background and only mask data in frame
    // Filter currently used is 3 x 3 sharpening filter with values as shown:
    // [  0, -1,  0,
    //   -1,  5, -1,
    //   0, -1,  0 ]
    var outputImageData = this.outputCtx.getImageData(0, 0, this.output.width, this.output.height); // filters you may try
    // [-1, -1, -1, -1, 9, -1, -1, -1, -1]
    //[0, -1, 0, -1, 5, -1, 0, -1, 0]

    var output = this.filters.convolute(outputImageData);
    this.outputCtx.putImageData(output, 0, 0);
  };

  _proto.drawPersonMask = function drawPersonMask() {
    this.outputCtx.drawImage(this.personMaskCanvas, 0, 0, this.personMaskWidth, this.personMaskHeight, 0, 0, this.output.width, this.output.height);
  };

  _proto.drawSegmentedBackground = function drawSegmentedBackground() {
    this.outputCtx.globalCompositeOperation = 'destination-over';
    this.outputCtx.imageSmoothingEnabled = true;
    this.outputCtx.imageSmoothingQuality = 'high';

    if (this.isVirtualBackground) {
      if (this.backgroundType === 'video' && this.backgroundVideo != null && this.backgroundVideo.readyState >= 4) {
        this.fitVideoToBackground();
      } else if (this.backgroundType === 'image') {
        this.fitImageToBackground();
      } else if (this.backgroundType === 'gif') {
        if (this.giflocalCount > this.gifFrames[this.gifFramesIndex].delay / DEFAULT_DELAY) {
          this.gifFramesIndex++;

          if (this.gifFramesIndex >= this.gifFrames.length) {
            this.gifFramesIndex = 0;
          }

          this.giflocalCount = 0;
        } else {
          this.giflocalCount++;
        }

        this.fitGifToBackground();
      }
    } else {
      this.addBlurToBackground();
    }
  };

  _proto.runSegmentation = /*#__PURE__*/function () {
    var _runSegmentation = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(skipProcessing) {
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.tfLite) {
                _context6.next = 5;
                break;
              }

              // const start = performance.now();
              this.resizeInputData();
              _context6.next = 4;
              return this.infer(skipProcessing);

            case 4:
              this.postProcessing(); // const end = performance.now();
              // this.log(TAG,"time taken",end -start);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function runSegmentation(_x3) {
      return _runSegmentation.apply(this, arguments);
    }

    return runSegmentation;
  }();

  _proto.fitVideoToBackground = function fitVideoToBackground() {
    this.fitData(this.backgroundVideo, this.backgroundVideo.videoWidth, this.backgroundVideo.videoHeight);
  };

  _proto.fitImageToBackground = function fitImageToBackground() {
    this.fitData(this.backgroundImage, this.backgroundImage.width, this.backgroundImage.height);
  };

  _proto.fitGifToBackground = function fitGifToBackground() {
    if (this.gifFrameImageData == null) {
      var dims = this.gifFrames[this.gifFramesIndex].dims;
      this.tempGifCanvas.width = dims.width;
      this.tempGifCanvas.height = dims.height;
      this.gifFrameImageData = this.tempGifContext.createImageData(dims.width, dims.height);
    } // set the patch data as an override


    this.gifFrameImageData.data.set(this.gifFrames[this.gifFramesIndex].patch);
    this.tempGifContext.putImageData(this.gifFrameImageData, 0, 0);
    this.fitData(this.tempGifCanvas, this.gifFrameImageData.width, this.gifFrameImageData.height);
  };

  _proto.fitData = function fitData(data, dataWidth, dataHeight) {
    var inputWidth, inputHeight, xoffset, yoffset;

    if (dataWidth / dataHeight < this.imageAspectRatio) {
      inputWidth = dataWidth;
      inputHeight = dataWidth / this.imageAspectRatio;
      xoffset = 0;
      yoffset = (dataHeight - inputHeight) / 2;
    } else {
      inputHeight = dataHeight;
      inputWidth = dataHeight * this.imageAspectRatio;
      yoffset = 0;
      xoffset = (dataWidth - inputWidth) / 2;
    }

    this.outputCtx.drawImage(data, xoffset, yoffset, inputWidth, inputHeight, 0, 0, this.output.width, this.output.height);
  };

  _proto.addBlurToBackground = /*#__PURE__*/function () {
    var _addBlurToBackground = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7() {
      var blurValue;
      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              blurValue = '15px';
              if (this.input.width <= 160) blurValue = '5px';else if (this.input.width <= 320) blurValue = '10px';else if (this.input.width <= 640) blurValue = '15px';else if (this.input.width <= 960) blurValue = '20px';else if (this.input.width <= 1280) blurValue = '25px';else if (this.input.width <= 1920) blurValue = '30px';
              this.outputCtx.filter = "blur(" + blurValue + ")";
              this.outputCtx.drawImage(this.input, 0, 0, this.output.width, this.output.height);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function addBlurToBackground() {
      return _addBlurToBackground.apply(this, arguments);
    }

    return addBlurToBackground;
  }();

  _proto.initSharpenFilter = function initSharpenFilter() {
    var _this3 = this;

    this.filters.tmpCanvas = document.createElement('canvas');
    this.filters.tmpCtx = this.filters.tmpCanvas.getContext('2d');

    this.filters.createImageData = function (w, h) {
      return _this3.filters.tmpCtx.createImageData(w, h);
    };

    this.filters.convolute = function (pixels, weights, opaque) {
      if (weights === void 0) {
        weights = [0, -1, 0, -1, 5, -1, 0, -1, 0];
      }

      var side = Math.round(Math.sqrt(weights.length));
      var halfSide = Math.floor(side / 2);
      var src = pixels.data;
      var sw = pixels.width;
      var sh = pixels.height; // pad output by the convolution matrix

      var w = sw;
      var h = sh;

      var output = _this3.filters.createImageData(w, h);

      var dst = output.data; // go through the destination image pixels

      var alphaFac = opaque ? 1 : 0;

      for (var y = 0; y < h; y = y + 1) {
        for (var x = 0; x < w; x = x + 1) {
          var dstOff = (y * w + x) * 4;

          if (src[dstOff + 3] === 0) {
            continue;
          } else if (x < w && y < h) {
            var sy = y;
            var sx = x; // calculate the weighed sum of the source image pixels that
            // fall under the convolution matrix

            var r = 0,
                g = 0,
                b = 0,
                a = 0;

            for (var cy = 0; cy < side; cy++) {
              for (var cx = 0; cx < side; cx++) {
                var scy = sy + cy - halfSide;
                var scx = sx + cx - halfSide;

                if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                  var srcOff = (scy * sw + scx) * 4;
                  var wt = weights[cy * side + cx];
                  r += src[srcOff] * wt;
                  g += src[srcOff + 1] * wt;
                  b += src[srcOff + 2] * wt;
                  a += src[srcOff + 3] * wt;
                }
              }
            }

            dst[dstOff] = r;
            dst[dstOff + 1] = g;
            dst[dstOff + 2] = b;
            dst[dstOff + 3] = a + alphaFac * (255 - a);
          }
        }
      }

      return output;
    };
  };

  return HMSVirtualBackgroundPlugin;
}();

export { HMSVirtualBackgroundPlugin };
//# sourceMappingURL=hms-virtual-background.esm.js.map
